<template>
  <div v-scroll="onScroll" v-resize="onResize">
    <v-row no-gutters v-if="fieldsLoading">
      <v-col v-for="n in 9" :key="n" cols="12" sm="6" lg="3">
       <v-sheet class="mt-2">
        <v-skeleton-loader class="mx-auto" type="list-item"></v-skeleton-loader>
      </v-sheet>
      </v-col>
    </v-row>
    <form-data :references.sync="formReferences" :model="transferObj" ref="transferOrderRef" v-else>
      <template slot="extraDetails" class="mb-3">
        <v-row>
          <v-col cols="12" class="text-right pt-0 pb-0">
            <v-btn fab x-small color="primary" v-if="showScrollToBottom" @click="goToBottom"><v-icon>mdi-chevron-down</v-icon></v-btn>
          </v-col>
        </v-row>
        <v-form ref="orderItems">
          <v-simple-table dense class="mt-4">
            <template v-slot:default>
              <thead>
                <tr>
                  <th>
                    {{ $t('message.warehouse.product') }}*
                    <v-progress-circular v-if="loadingProducts" indeterminate color="primary"></v-progress-circular>
                  </th>
                  <th>{{ $t('message.whOrder.minQty') }}</th>
                  <th>{{ $t('message.whOrder.orderQty') }}*</th>
                  <th>{{ $t('message.common.comments') }}</th>
                  <th v-if="transferObj.status !== 'request' && transferObj.status !== 'draft'">{{ $t('message.layout.location') }}*</th>
                  <th v-if="transferObj.status !== 'request' && transferObj.status !== 'draft'">{{ $t('message.whOrder.pickQty') }}</th>
                  <th v-if="transferObj.status !== 'request' && transferObj.status !== 'draft'">
                    {{ $t('message.stock.batchOrWin') }}
                    <v-progress-circular v-if="loadingBatchNumber" indeterminate color="primary"></v-progress-circular>
                  </th>
                  <th v-if="receiveStock || transferObj.status === 'partiallyreceived' || transferObj.status === 'received'">{{ $t('message.whOrder.recQty') }}</th>
                  <th v-if="receiveStock || transferObj.status === 'partiallyreceived' || transferObj.status === 'received'">{{ $t('message.layout.location') }}*</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(element, index) in orderItems" :key="`${index}_item`" class="pt-4">
                  <v-text-field type="text" class="hidden-sm-and-up hidden-sm-and-down" v-model="element.id"></v-text-field>
                  <td width="20%" class="alignSub">
                     <v-autocomplete v-model="element.productid" :items="element.products" autocomplete="off"
                      @keyup="$event.keyCode !== 13 && $event.keyCode !== 9 ? loadProducts(`searchInput${index}`, index, $event) : ''"
                      :ref="`searchInput${index}`" outlined dense
                      :loading="element.productLoader"
                      @click="toggleAllProducts(index, SHOW)"
                      @focusout="toggleAllProducts(index, HIDE, element.productid)"
                      @change="getActiveProuct(index, element.productid)"
                      item-text="productName" item-value="id" :disabled="disableFormFields"
                      hide-details :placeholder="$t('message.common.typeHere')"></v-autocomplete>
                  </td>
                  <td width="5%" class="alignSub">
                    {{ element.minstock }}
                  </td>
                  <td width="8%" class="alignSub">
                    <v-text-field v-model="element.qty" :disabled="element.isMaximumUsed" outlined dense :ref="`qty_${index}`"
                      :rules="element.productid ? element.qty ? $_norwegianNumberValidation : $_requiredValidation : []" hide-details @change="autoSave()"
                      :placeholder="$t('message.common.typeHere')"></v-text-field>
                  </td>
                  <td width="15%" class="alignSub">
                    <v-text-field outlined dense v-model="element.comments" type="text" :disabled="disableFormFields" hide-details :placeholder="$t('message.common.typeHere')" @change="changesMade()"></v-text-field>
                  </td>
                  <td width="15%" class="alignSub"
                    v-if="transferObj.status !== 'request' && transferObj.status !== 'draft'">
                    <template v-if="element.adjustorder">
                      <v-autocomplete autocomplete="off"
                        @keyup="$event.keyCode !== 13 ? loadLocation(`searchLocation${index}`, index, $event, element.productid) : ''"
                        :ref="`searchLocation${index}`"
                        @click="toggleLocation(index, SHOW)"
                        :disabled="element.pickedorders && element.pickedorders.length > 0" v-model="element.adjustorder.locationid"
                        :rules="$_requiredValidation" :items="element.locations"
                        item-text="location_name" item-value="locationid"
                        @change="setBatchNumbers(index, element.productid, element.adjustorder.locationid)"
                        hide-details full-width outlined dense :placeholder="$t('message.order.searchLocation')">
                        <template v-slot:no-data>
                          <span class="pa-1 caption">{{ $t('message.common.noResults') }}</span>
                        </template>
                      </v-autocomplete>
                      <!-- <v-autocomplete class="mt-1" outlined dense v-model="element.adjustorder.locationid" :rules="$_requiredValidation" :items="element.locations"
                        item-text="location_name" item-value="locationid" autocomplete="off"
                        :disabled="element.pickedorders && element.pickedorders.length > 0"
                        hide-details :placeholder="$t('message.common.typeHere')"
                        @change="setBatchNumbers(index, element.productid, element.adjustorder.locationid)"
                        ></v-autocomplete> -->
                      </template>
                  </td>
                  <td v-if="transferObj.status !== 'request' && transferObj.status !== 'draft'" width="7%" class="alignSub">
                    <template v-if="element.pickedorders && element.pickedorders.length > 0">
                      <div v-for="(item) in element.pickedorders" :key="item.id">
                        <v-text-field outlined dense hide-details class="mb-1" v-model="item.pickedqty" disabled></v-text-field>
                      </div>
                    </template>
                    <v-text-field class="mb-1" outlined dense v-if="!element.isMaximumUsed"
                     @keyup="validateQtyHandler(index, element.qty)" v-model="element.pickedqty" hide-details :placeholder="$t('message.common.typeHere')"
                     :rules="element.receivedqty ? $_norwegianNumberValidation : !element.pickedorders.length ? $_requiredValidation : []"></v-text-field>
                  </td>
                  <td v-if="transferObj.status !== 'request' && transferObj.status !== 'draft'" width="12%" class="alignSub">
                    <template v-if="element.isbatch">
                      <template v-if="element.pickedorders && element.pickedorders.length > 0">
                        <div v-for="(item) in element.pickedorders" :key="item.id">
                          <v-text-field outlined dense hide-details class="mb-1" v-model="item.batchnumber" disabled></v-text-field>
                        </div>
                      </template>
                      <v-autocomplete autocomplete="off" v-if="element.pickedqty && !element.isMaximumUsed"
                        v-model="element.batchnumber"
                        @change="checkQtyOfBatchNumber(index, element.batchnumber)"
                        :rules="$_requiredValidation" :items="element.batch_numbers" item-text="batchnumber_ref" item-value="batchnumber"
                        hide-details full-width outlined dense :placeholder="$t('message.common.typeHere')"></v-autocomplete>
                      <div style="min-height: 40px" v-if="!element.pickedqty && !element.isMaximumUsed"></div>
                    </template>
                  </td>
                  <td width="7%" v-if="receiveStock || transferObj.status === 'partiallyreceived' || transferObj.status === 'received'" class="alignSub">
                    <template v-if="element.receivedorders && element.receivedorders.length > 0">
                      <div v-for="(item, index) in element.receivedorders" :key="`${index}_qty`">
                        <v-text-field outlined dense hide-details class="mb-1" v-model="item.pickedqty" disabled></v-text-field>
                      </div>
                    </template>
                  </td>
                  <td width="12%" v-if="receiveStock || transferObj.status === 'partiallyreceived' || transferObj.status === 'received'" class="alignSub">
                    <div v-for="(item, orderIndex) in element.receivedorders" :key="`${orderIndex}_location`">
                      <!-- <v-autocomplete class="mt-1" outlined dense v-model="item.locationid" :rules="$_requiredValidation"
                        :items="listOfLocation" :disabled="item.ispicked"
                        item-text="name" item-value="id" autocomplete="off" @change="autoSave()"
                        hide-details :placeholder="$t('message.common.typeHere')"></v-autocomplete> -->
                        <v-autocomplete v-model="item.locationid" :items="item.listOfLocation" autocomplete="off" class="mt-1"
                          @keyup="$event.keyCode !== 13 ? getWarehouseLocations(`searchDestinationLocation${orderIndex}`, index, orderIndex, $event, transferObj.destinationwarehouseid) : ''"
                          :disabled="item.ispicked"
                          :ref="`searchDestinationLocation${orderIndex}`" outlined dense
                          @click="toggleLocations(index, SHOW, null, orderIndex)"
                          @change="changesMade()"
                          :loading="item.destinationLocationLoading"
                          item-text="name" item-value="id" :rules="$_requiredValidation"
                          hide-details :placeholder="$t('message.common.typeHere')">
                        </v-autocomplete>
                    </div>
                  </td>
                  <td class="alignSub" v-if="transferObj.status === 'draft'">
                    <v-btn class="mx-2" text fab dark small color="primary" @click="deleteProductRow(index, element.id)">
                      <v-icon dark>mdi-minus-circle</v-icon>
                    </v-btn>
                  </td>
                </tr>
              </tbody>
              <tfoot class="text-right" v-if="needToReceive">
                <tr>
                  <td colspan="5" class="pt-1 pb-2">
                    <v-btn color="primary" @click="receivePickedItemsHandler" :disabled="receiveStock">{{ $t('message.common.receive') }}</v-btn>
                  </td>
                </tr>
              </tfoot>
            </template>
          </v-simple-table>
        </v-form>
        <v-btn class="mx-2" fab dark small color="primary" @click="addProductRowHandler" v-if="transferObj.warehouseid && !disableFormFields">
          <v-icon dark>mdi-plus</v-icon>
        </v-btn>
        <v-fab-transition>
          <v-btn fab bottom right color="primary" id="scroll__top" fixed v-if="showScrollToTop" @click="scrollToTop">
            <v-icon dark>mdi-chevron-up</v-icon>
          </v-btn>
        </v-fab-transition>
      </template>
    </form-data>
  </div>
</template>
<script>
/* eslint-disable */
import { mapState } from 'vuex'
import FormTemplate from '@/components/FormTemplate'
import CONSTANTS from '@/utils/warehouse.json'
import goTo from 'vuetify/lib/services/goto'
export default {
  data () {
    return {
      transferObj: {
        id: this.$route.params.transfer_id,
        status: 'draft',
        priority: 'medium',
        datePicker: ''
      },
      fieldsLoading: false,
      loading: false,
      orderItems: [],
      listOfProducts: [],
      listOfLocation: [],
      disableFormFields: false,
      disableStatusChange: false,
      listOfAllProducts: [],
      loadingProducts: false,
      loadingBatchNumber: false,
      orderStatus: '',
      needToReceive: false,
      receiveStock: false,
      isAutoSave: false,
      destinationLocationLoading: false,
      showScrollToTop: false,
      showScrollToBottom: false
    }
  },
  components: {
    'form-data': FormTemplate
  },
  computed: {
    ...mapState(['FORM_TYPE', 'listOfWarehouse', 'listOfLocations']),
    statusList () {
      if (!this.$route.params.transfer_id) {
        return [{
          name: this.$t('message.common.draft'), id: CONSTANTS.DRAFT
        }]
      } else if (this.orderStatus === CONSTANTS.DRAFT) {
        return [{
          name: this.$t('message.common.draft'), id: CONSTANTS.DRAFT
        }, {
          name: this.$t('message.common.request'), id: CONSTANTS.REQUEST
        }]
      } else if (this.orderStatus === CONSTANTS.REQUEST || this.orderStatus === CONSTANTS.INPROGRESS) {
        return [{
          name: this.$t('message.common.request'), id: CONSTANTS.REQUEST
        }, {
          name: this.$t('message.common.inProgress'), id: CONSTANTS.INPROGRESS
        }]
      } else if (this.orderStatus !== CONSTANTS.DRAFT && this.orderStatus !== CONSTANTS.REQUEST && this.orderStatus !== CONSTANTS.INPROGRESS) {
        return [{
          name: this.$t('message.common.picked'), id: CONSTANTS.PICKED
        }, {
          name: this.$t('message.common.partiallyPicked'), id: CONSTANTS.PARTIALLYPICKED
        }, {
          name: this.$t('message.common.picked'), id: CONSTANTS.PICKED
        }, {
          name: this.$t('message.common.received'), id: CONSTANTS.RECEIVED
        }, {
          name: this.$t('message.common.partiallyReceived'), id: CONSTANTS.PARTIALLYRECEIVED
        }]
      }
      return []
    },
    pageHeight () {
      return document.body.scrollHeight
    },
    formReferences () {
      return {
        title: this.$route.params.transfer_id ? `${this.$t('message.whOrder.updateTransferOrder')} (${this.transferObj.number || ''})` : this.$t('message.whOrder.addTransferOrder'),
        properties: [{
          model: 'orderdate',
          rules: this.$_requiredValidation,
          type: this.FORM_TYPE.DATEPICKER,
          class: 'lg2 sm6 xs12',
          picker: 'datePicker',
          menu: 'dateMenu',
          color: 'primary lighten-1',
          disabled: this.disableFormFields,
          label: this.$t('message.whOrder.orderDate'),
          change: this.changesMade
        }, {
          model: 'warehouseid',
          type: this.FORM_TYPE.AUTO_COMPLETE,
          disabled: this.disableFormFields,
          rules: this.$_requiredValidation,
          items: this.listOfWarehouse,
          click: (term) => null,
          is_list: false,
          term: '',
          select_text: 'name',
          select_value: 'id',
          label: this.$t('message.whOrder.sourceWH'),
          class: 'lg2 sm6',
          change: this.changesMade
        }, {
          model: 'destinationwarehouseid',
          type: this.FORM_TYPE.AUTO_COMPLETE,
          disabled: this.disableFormFields,
          rules: this.$_requiredValidation,
          items: this.listOfWarehouse,
          click: (term) => null,
          is_list: false,
          term: '',
          select_text: 'name',
          select_value: 'id',
          label: this.$t('message.whOrder.destinationWH'),
          class: 'lg2 sm6',
          change: this.changesMade
        }, {
          model: 'priority',
          type: this.FORM_TYPE.SELECT,
          disabled: this.disableFormFields,
          rules: [],
          items: this.$_priorityList,
          term: '',
          is_list: true,
          select_text: 'text',
          select_value: 'value',
          label: this.$t('message.layout.priority'),
          class: 'lg2 sm6',
          change: this.changesMade
        }, {
          model: 'status',
          type: this.FORM_TYPE.SELECT,
          rules: [],
          items: this.statusList,
          term: '',
          disabled: this.disableStatusChange,
          is_list: true,
          select_text: 'name',
          select_value: 'id',
          label: this.$t('message.customer.status'),
          class: 'lg2 sm6'
        }, {
          model: 'comments',
          type: this.FORM_TYPE.TEXTAREA,
          label: this.$t('message.common.comments'),
          class: 'lg6 sm6',
          change: this.changesMade
        }],
        buttons: [{
          name: 'action_handler',
          color: 'success',
          label: this.$route.params.transfer_id ? this.$t('message.common.update') : this.$t('message.common.save'),
          click: () => this.saveWithoutAuto(this.SAVE),
          loading: this.loading,
          is_show: true
        }, {
          name: 'action_handler_update',
          color: 'primary',
          label: this.$t('message.common.updateAndClose'),
          click: () => this.saveWithoutAuto(this.UPDATE_CLOSE),
          loading: this.loading,
          is_show: this.$route.params.transfer_id
        }, {
          name: 'back_to_list',
          color: 'info',
          // eslint-disable-next-line
          click: () => this.$router.push('/w_h/order'),
          label: this.$t('message.common.backToList'),
          to: '/w_h/order',
          is_show: true
        }, {
          name: 'delete_btn',
          color: 'error',
          label: this.$t('message.common.delete'),
          click: this.deleteHandler,
          disabled: this.disableStatusChange,
          is_show: this.$route.params.transfer_id
        }],
        end_buttons: [{
          name: 'download',
          color: 'teal',
          click: () => this.$parent.$parent.printOrder({ ...this.transferObj, type_ref: 'transfer' }),
          loading: false,
          label: this.$t('message.order.download'),
          class: 'text-right',
          is_show: this.$route.params.transfer_id
        }, {
          name: 'share',
          color: 'info',
          label: this.$t('message.order.share'),
          click: () => this.$parent.$parent.sendReport({ ...this.transferObj, type_ref: 'transfer' }),
          loading: false,
          class: 'text-right',
          is_show: this.$route.params.transfer_id
        }]
      }
    }
  },
  mounted () {
    this.transferObj.orderdate = this.$formatter.formatDate(new Date(), 'YYYY-MM-DD', 'DD.MM.YYYY')
    if (this.transferObj.id) {
      this.isAutoSave = this.$route.query.autosave
      this.getSingleRecordHandler(true)
      window.history.pushState({ path: this.$route.path }, '', this.$route.path)
    }
    // if (this.transferObj.id) this.getSingleRecordHandler()
    let text = this.$t('message.common.deleteSuccess')
    this.$eventBus.$on('deleteSuccess', (data) => {
      if (data === this.ORDERITEMS) {
        this.$root.$emit('snackbar', { snackbar: true, color: 'success', text })
        this.$store.commit('hideDialog')
        if (!data.orderItemsAutoSave) this.getSingleRecordHandler()
      } else {
        this.$root.$emit('snackbar', { snackbar: true, color: 'success', text })
        this.$store.commit('isChangesMade', false)
        this.$store.commit('hideDialog')
        this.$router.push('/w_h/order')
      }
    })
    // read supporting list items
    this.$store.dispatch('getWarehouse')
      .then(() => {
        if (!this.transferObj.id) {
          if (this.listOfWarehouse && this.listOfWarehouse.length === 1) {
            let getWarehouse = this.listOfWarehouse[0]
            let model = Object.assign({ ...this.transferObj }, { warehouseid: getWarehouse.id, destinationwarehouseid: getWarehouse.id })
            this.transferObj = model
          }
        }
      })
    // this.$store.dispatch('getWarehouseLocations')
    this.transferObj.type = 'transfer'
  },
  watch: {
    'transferObj.warehouseid' (val) {
      if (val) {
        this.orderItems = []
        this.addProductRowHandler()
      } else {
        this.clearLocationRefForWarehouse()
      }
    },
    'transferObj.destinationwarehouseid' (val) {
      this.listOfLocation = []
      this.getLocation(val)
    },
    'transferObj.status' (val) {
      if (!val || val === CONSTANTS.DRAFT) this.disableFormFields = false
      else this.disableFormFields = true
    },
    'transferObj.datePicker' (val) {
      if (val) {
        this.transferObj.orderdate = this.$formatter.formatDate(val, 'YYYY-MM-DD', 'DD.MM.YYYY')
      }
    }
  },
  methods: {
    autoSave () {
      if (this.orderItems.length >= 1) {
        let canSave = true
        this.orderItems.every((element) => {
          if (!element.productid && !element.qty) {
            canSave = false
            return false
          } else return true
        })
        if (canSave) this.saveUpdateHandler(this.SAVE, true)
      }
    },
    saveWithoutAuto (type) {
      setTimeout(() => {
        if (!this.loading) this.saveUpdateHandler(type)
      }, 300)
    },
    clearLocationRefForWarehouse () {
      let productItems = this.$formatter.cloneVariable(this.orderItems)
      for (let i = 0; i < productItems.length; i++) {
        let productItem = productItems[i]
        productItem.adjustorder.locationid = 0
        this.$set(this.orderItems, i, productItem)
      }
    },
    addProductRowHandler () {
      this.orderItems.push({ products: [], locationid: 0, adjustorder: {} })
    },
    // Searching products
    loadProducts (term, index, event) {
      if ([32, 37, 38, 39, 40, 30].indexOf(event.keyCode) > -1) return
      let searchText = this.$refs[term][0].lazySearch
      if (searchText !== null) {
        let model = {
          'filter': `number contains '${searchText}' OR name contains  '${searchText}'`,
          'additionalfilters': [`isactive eq 1`],
          'skip': 0,
          'limit': 50,
          'expand': [{
            select: ['is_generate_win'],
            model: 'ProductWorkFlow',
            on_field: 'id',
            on_parent_field: 'workflow_id'
          }],
          'order_by': {
            'field': 'number',
            'asc_or_desc': 'asc'
          }
        }
        this.$set(this.orderItems, index, { ...this.orderItems[index], productLoader: true })
        this.$_executeApi('post', 'products/query', model).then((response) => {
          this.orderItems[index].products = []
          if (response.data.length > 0) {
            response.data.forEach(element => {
              element.productName = element.number ? `${element.number} - ${element.name}` : element.name
            })
            this.orderItems[index].products = response.data
          }
        }).finally(() => {
          this.$set(this.orderItems, index, { ...this.orderItems[index], productLoader: false })
        })
      }
    },
    getLocation (id) {
      let query = {
        select: ['id', 'name', 'warehouseid', 'isdefault'],
        filter: `isactive eq 1 and warehouseid eq ${id}`,
        'order_by': {
          'field': 'name',
          'asc_or_desc': 'asc'
        }
      }
      this.clearLocationRefForWarehouse()
      this.$_executeApi('post', 'warehouselocations/query', query).then(response => {
        this.listOfLocation = response.data
      })
    },
    getWarehouseLocations (term, index, orderIndex, event, warehouseid) {
      if ([32, 37, 38, 39, 40, 30].indexOf(event.keyCode) > -1) return
      let searchText = this.$refs[term][0].lazySearch
      if (searchText !== null) {
        let currentItem = this.orderItems[index]
        currentItem.receivedorders[orderIndex].destinationLocationLoading = true
        this.$set(this.orderItems, index, currentItem)
        let query = {
          select: ['id', 'name', 'warehouseid', 'isdefault'],
          additionalfilters: [`name contains  '${searchText}'`],
          skip: 0,
          limit: 50,
          filter: `isactive eq 1 and warehouseid eq ${warehouseid}`,
          'order_by': {
            'field': 'name',
            'asc_or_desc': 'asc'
          }
        }
        this.$_executeApi('post', 'warehouselocations/query', query).then((response) => {
          currentItem.receivedorders[orderIndex].listOfLocation = response.data
          this.$set(this.orderItems, index, currentItem)
        }).finally(() => {
          let updatedItem = this.orderItems[index]
          updatedItem.receivedorders[orderIndex].destinationLocationLoading = false
          this.$set(this.orderItems, index, updatedItem)
        })
      }
    },
    toggleLocations (index, action, locationid, orderIndex) {
      // this.$parent.$parent.toggleAllLocations(index, actions, locationid)
      let items = this.$formatter.cloneVariable(this.orderItems)
      let recievedOrderItem = items[index].receivedorders[orderIndex]
      if (action === this.HIDE && items[index] && recievedOrderItem && recievedOrderItem[orderIndex]) {
        let locations = recievedOrderItem.listOfLocation.filter(x => x.id === locationid)
        recievedOrderItem.listOfLocation = locations
      }
      this.$set(this.orderItems[index].receivedorders, orderIndex, recievedOrderItem)
      // if (this.orderItems && this.orderItems.length > 0 && this.orderItems[index]) this.$set(this.orderItems, index, items[index])
    },
    getSingleRecordHandler (showLoader) {
      this.fieldsLoading = showLoader
      this.$_getSingleRecordHandler(`${this.WH_ORDER}/${this.transferObj.id}`)
        .then((result) => {
          if (result.data) {
            let transformDate = { date: { list: ['orderdate'], from: 'DD-MM-YYYYTHH:mm:ss', to: 'DD.MM.YYYY' } }
            let model = this.$_formatModel(result.data, transformDate)
            this.transferObj = model
            this.orderStatus = model.status
            const getType = this.$_orderType.find(x => x.value === this.transferObj.type)
            const type = getType ? getType.text : this.transferObj.type
            this.transferObj = Object.assign({ ...this.transferObj }, { type })
            if (this.transferObj.status !== CONSTANTS.DRAFT && this.transferObj.status !== CONSTANTS.REQUEST && this.transferObj.status !== CONSTANTS.INPROGRESS) this.disableStatusChange = true
            this.getOrderItemsHandler(this.transferObj.id, this.isAutoSave)
          }
        })
    },
    getOrderItemsHandler (id, autoSave) {
      let url = `warehouseorderitems/get_by_order/${id}`
      this.$_executeApi('get', url)
        .then(async (response) => {
          let data = response.data
          let transformNumber = { number: { list: ['qty', 'onstock', 'minstock', 'pickedqty', 'receivedqty'], format: 'replaceDotWithComma' } }
          data = this.$_formatListModel(data, transformNumber)
          this.receiveStock = false
          let result = []
          for (let i = 0; i < data.length; i++) {
            data[i].products = []
            data[i].locations = []
            data[i].products.push({
              id: data[i].productid,
              productName: data[i].productnumber ? `${data[i].productnumber} - ${data[i].productname}` : data[i].productname
            })
            if (data[i].adjustorder.locationid) {
              if (data[i].adjustorder.locationid) {
                data[i].locations.push({
                  locationid: data[i].adjustorder.locationid,
                  location_name: `${data[i].adjustorder.locationname} (${this.$formatter.replaceDotWithComma(data[i].adjustorder.availablestockqty) || '0, 00'})`
                })
              }
            }
            // data[i].locations = await this.getStockHandler(0, data[i].productid)
            if (this.transferObj.status !== 'draft' && this.transferObj.status !== 'request' && data[i].adjustorder.locationid) data[i].batch_numbers = await this.getBatchNumbersHandler(data[i].productid, data[i].adjustorder.locationid)
            let pickedqtyRef = 0
            if (data[i].pickedorders) {
              data[i].pickedorders.forEach(pickElement => {
                pickedqtyRef += pickElement.pickedqty
                pickElement.pickedqty = this.$formatter.replaceDotWithComma(pickElement.pickedqty)
              })
              data[i].pickedqtyRef = pickedqtyRef

              let qty = +this.$formatter.replaceCommaWithDot(data[i].qty || 0)
              if (qty === data[i].pickedqtyRef || qty < data[i].pickedqtyRef) data[i].isMaximumUsed = true
              else data[i].isMaximumUsed = false

              // assign all the records to received
              let receivedQtyRef = 0
              data[i].receivedorders.map(receivedElement => {
                receivedQtyRef += receivedElement.receivedqty
                receivedElement.ispicked = true
                receivedElement.listOfLocation = [{
                  id: receivedElement.locationid,
                  name: receivedElement.locationname
                }]
                receivedElement.receivedqty = this.$formatter.replaceDotWithComma(receivedElement.receivedqty)
                receivedElement.pickedqty = this.$formatter.replaceDotWithComma(receivedElement.receivedqty)
                return receivedElement
              })
              data[i].receivedQtyRef = receivedQtyRef

              if (data[i].pickedqtyRef && data[i].pickedqtyRef !== data[i].receivedQtyRef) this.needToReceive = true
              if (!this.needToReceive) this.needToReceive = false
            }
            data[i].pickedqty = ''
            result.push(data[i])
          }
          this.orderItems = result
          this.loadingProducts = false
          this.loadingBatchNumber = false
          if (autoSave) {
            setTimeout(() => {
              this.$refs[`qty_${this.orderItems.length - 1}`][0].focus()
              this.isAutoSave = false
            }, 100)
          }
        })
        .finally(() => {
          this.fieldsLoading = false
        })
    },
    receivePickedItemsHandler () {
      this.receiveStock = true
      let allItems = this.$formatter.cloneVariable(this.orderItems)
      for (let i = 0; i < allItems.length; i++) {
        let itemPickedObj = this.$formatter.cloneVariable(allItems[i].pickedorders)
        let itemReceivedObj = this.$formatter.cloneVariable(allItems[i].receivedorders)
        // asign all the pickedorder to receivedorders
        if (allItems[i].receivedorders && allItems[i].receivedorders.length <= 0) {
          itemPickedObj.map(x => {
            x.id = 0
            x.locationid = 0
            return x
          })
          allItems[i].receivedorders = itemPickedObj
          this.$set(this.orderItems, i, { ...allItems[i] })
        } else if (itemReceivedObj && itemReceivedObj.length > 0) { // asign partial pickedorder to receivedorders
          let tobereceived = itemPickedObj
          tobereceived.map(x => {
            x.id = 0
            x.locationid = 0
            x.ispicked = false
            return x
          })
          for (let j = 0; j < itemReceivedObj.length; j++) {
            if (itemReceivedObj[j].id) itemReceivedObj[j].ispicked = true
            itemReceivedObj[j].pickedqty = itemReceivedObj[j].receivedqty
            tobereceived[j] = this.$formatter.cloneVariable(itemReceivedObj[j])
          }
          allItems[i].receivedorders = this.$formatter.cloneVariable(tobereceived)
          this.$set(this.orderItems, i, { ...allItems[i] })
        }
      }
    },
    saveUpdateHandler (type, autoSave) {
      if (autoSave || this.$refs.transferOrderRef.$refs.validateForm.validate()) {
        if (autoSave ? this.$refs.orderItems && this.$refs.orderItems.validate() : true) {
          this.loading = true
          let transformData = { date: { list: ['orderdate'], from: 'DD.MM.YYYY', to: 'YYYY-MM-DDTHH:mm:ss' } }
          let model = this.$formatter.cloneVariable(this.transferObj)
          model = this.$_formatModel(model, transformData)
          let url = this.WH_ORDER
          model.type = CONSTANTS.TRANSFER
          this.$_saveUpdateHandler(url, model, false, autoSave)
            .then((response) => {
              this.transferObj.id = response.id
              this.$store.commit('isChangesMade', false)
              this.saveOrderItemsHandler(response.id, type, autoSave)
            })
        }
      } else this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: this.$t('message.common.validationIssue') })
      // if (this.$refs.transferOrderRef.$refs.validateForm.validate()) {
      //   let transformData = { date: { list: ['orderdate'], from: 'DD.MM.YYYY', to: 'YYYY-MM-DDTHH:mm:ss' } }
      //   let model = this.$formatter.cloneVariable(this.transferObj)
      //   model = this.$_formatModel(model, transformData)
      //   let url = this.WH_ORDER
      //   model.type = CONSTANTS.TRANSFER
      //   this.$_saveUpdateHandler(url, model)
      //     .then((response) => {
      //       this.$store.commit('isChangesMade', false)
      //       this.saveOrderItemsHandler(response.id, type)
      //     })
      // } else this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: this.$t('message.common.validationIssue') })
    },
    saveOrderItemsHandler (id, type, autoSave) {
      if (this.$refs.orderItems.validate()) {
        let transformData = { number: { list: ['qty', 'pickedqty', 'receivedqty'], format: 'replaceCommaWithDot' } }
        let model = this.$formatter.cloneVariable(this.orderItems.filter(x => x.productid))
        model = this.$_formatListModel(model, transformData)
        model.map(x => {
          if (x.adjustorder.locationid) {
            if (!x.receivedorders) x.receivedorders = []
            x.receivedorders.map(receivedElement => {
              let qty = 0
              qty = this.$formatter.replaceCommaWithDot(receivedElement.pickedqty)
              receivedElement.receivedqty = qty
              return receivedElement
            })
            if (!x.pickedorders) x.pickedorders = []
            if (x.pickedqty) {
              x.pickedorders.push({ batchnumber: x.batchnumber, pickedqty: this.$formatter.replaceCommaWithDot(x.pickedqty), locationid: x.adjustorder.locationid })
            }
            x.pickedorders.map(pickElement => {
              pickElement.pickedqty = this.$formatter.replaceCommaWithDot(pickElement.pickedqty)
              return pickElement
            })
            return x
          }
        })
        let orderItemsJSON = { 'items': this.$formatter.cloneVariable(model) }
        let url = `/warehouseorderitems/bulk_save/${id}`
        this.$_executeApi('post', url, orderItemsJSON).then(response => {
          if (autoSave) {
            this.orderItems.forEach((element, index) => {
              element.id = response.data[index].id
              element.orderid = id
            })
          }
        }).finally(() => {
          this.loading = false
          this.navigateHandler(type, id, autoSave)
        })
      } else {
        this.loading = false
        this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: this.$t('message.common.validationIssue') })
      }
    },
    async getActiveProuct (index, productid) {
      let getProduct = this.orderItems[index].products
      if (getProduct) {
        let stockObjs = []
        let result = getProduct.find(x => x.id === productid)
        if (result && result.ispackage) {
          this.loadingProducts = true
          this.getProductsByPackage(productid, index)
        }
        // else {
        //   stockObjs = await this.getStockHandler(index, productid)
        // }
        let getObj = this.$formatter.cloneVariable(this.orderItems[index])
        getObj.minstock = this.$formatter.replaceDotWithComma(result.minstock || 0)
        getObj.isbatch = result.batchrequired || result.productworkflow_is_generate_win
        getObj.adjustorder.locationid = 0
        getObj.locations = stockObjs
        this.$set(this.orderItems, index, getObj)
      }
    },
    async getProductsByPackage (id, index) {
      let query = {
        select: [],
        expand: [{
          'model': 'Product',
          'on_field': 'id',
          'on_parent_field': 'productid',
          inner_expand: {
            select: ['is_generate_win'],
            model: 'ProductWorkFlow',
            on_field: 'id',
            on_parent_field: 'workflow_id'
          }
        }],
        filter: `packageid eq '${id}'`
      }
      this.$_executeApi('post', 'productpackages/query', query)
        .then(async (response) => {
          let getAllProducts = []
          let list = response.data
          for (let i = 0; i < list.length; i++) {
            let products = [{ id: list[i].product_id, productName: list[i].product_number ? `${list[i].product_number} - ${list[i].product_name}` : list[i].product_name }]
            // let locations = await this.getStockHandler(index, list[i].product_id) || []
            getAllProducts.push({ products,
              productid: list[i].product_id,
              minstock: list[i].product_minstock ? this.$formatter.replaceDotWithComma(list[i].product_minstock) : 0,
              adjustorder: { locationid: 0 },
              // locations: [],
              isbatch: list[i].product_batchrequired || list[i].productworkflow_is_generate_win,
              productName: list[i].product_number ? `${list[i].product_number} - ${list[i].product_name}` : list[i].product_name })
          }
          let getExistingItems = this.$formatter.cloneVariable(this.orderItems)
          getExistingItems.splice(index, 1)
          getExistingItems.push(...getAllProducts)
          this.orderItems = getExistingItems
        })
        .finally(() => {
          this.loadingProducts = false
        })
    },
    async setBatchNumbers (index, productid, locationid) {
      // this.changesMade()
      if (productid && locationid) {
        let batches = await this.getBatchNumbersHandler(productid, locationid)
        let getObj = this.$formatter.cloneVariable(this.orderItems[index])
        getObj.batch_numbers = batches
        getObj.adjustorder.batchnumber = 0
        this.$set(this.orderItems, index, getObj)
        // this.autoSave()
      }
    },
    getBatchNumbersHandler (productid, locationid) {
      return new Promise((resolve, reject) => {
        this.$_executeApi('get', `/warehouseorderitems/get_batchnumbers_by_location?product_id=${productid}&location_id=${locationid}`)
          .then((result) => {
            let model = result.data
            let transformData = { number: { list: ['onstock'], format: 'replaceDotWithComma' } }
            model = this.$_formatListModel(model, transformData)
            model.map(x => {
              x.batchnumber_ref = ''
              x.batchnumber_ref = `${x.batchnumber} ${x.is_defect_batch ? '(B)' : ''} (${x.onstock})`
              return x
            })
            resolve(model)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    loadLocation (ref, index, event, productid) {
      if ([32, 37, 38, 39, 40, 30].indexOf(event.keyCode) > -1) return
      let searchText = this.$refs[ref][0].lazySearch
      if (searchText) {
        this.$set(this.orderItems, index, { ...this.orderItems[index], locationLoading: true })
        this.$_executeApi('get', `/stocks/get_warehouse_locations_with_stock?product_id=${productid}&warehouse_id=${this.transferObj.warehouseid}&search_term=${searchText}`)
          .then((result) => {
            let model = result.data
            let transformData = { number: { list: ['onstock'], format: 'replaceDotWithComma' } }
            model = this.$_formatListModel(model, transformData)
            model.map(x => {
              x.location_name = `${x.location_name} (${x.onstock})`
              return x
            })
            this.$set(this.orderItems, index, { ...this.orderItems[index], locations: model })
          }).finally(() => {
            this.$set(this.orderItems, index, { ...this.orderItems[index], locationLoading: false })
          })
      }
    },
    toggleLocation (index, action, locationid) {
      let items = this.$formatter.cloneVariable(this.orderItems)
      if (action === this.HIDE && items[index] && items[index].adjustorder && items[index].locations) {
        let locations = items[index].locations.filter(x => x.locationid === locationid)
        items[index].locations = locations
      }
      if (this.orderItems && this.orderItems.length > 0 && this.orderItems[index]) this.$set(this.orderItems, index, items[index])
    },
    // getStockHandler (index, productid) {
    //   return new Promise((resolve, reject) => {
    //     this.$_executeApi('get', `/stocks/get_product_by_warehouse?product_id=${productid}&warehouse_id=${this.transferObj.warehouseid}`)
    //       .then((result) => {
    //         let model = result.data
    //         let transformData = { number: { list: ['on_stock'], format: 'replaceDotWithComma' } }
    //         model = this.$_formatListModel(model, transformData)
    //         model.map(x => {
    //           x.location_name = `${x.location_name} (${x.on_stock})`
    //           return x
    //         })
    //         resolve(model)
    //       })
    //       .catch((err) => {
    //         reject(err)
    //       })
    //   })
    // },
    validateQtyHandler (index, qty) {
      var totalQty = 0
      var loopCount = 0
      var receivedCount = 0
      // CHECK WITH ENTER QTY
      if (this.orderItems[index].pickedorders) {
        for (let i = 0; i < this.orderItems[index].pickedorders.length; i++) {
          if (i !== this.orderItems[index].pickedorders.length) {
            let receivedQty = this.$formatter.replaceCommaWithDot(this.orderItems[index].pickedorders[i].pickedqty)
            loopCount += parseFloat(receivedQty)
          }
        }
      }
      if (this.orderItems[index].receivedorders) {
        for (let i = 0; i < this.orderItems[index].receivedorders.length; i++) {
          let receivedQty = this.$formatter.replaceCommaWithDot(this.orderItems[index].receivedorders[i].receivedqty)
          receivedCount += parseFloat(receivedQty)
        }
      }
      totalQty += parseFloat(loopCount)
      if (this.orderItems[index].pickedqty) {
        let parentPickedQty = this.$formatter.replaceCommaWithDot(this.orderItems[index].pickedqty)
        totalQty += parseFloat(parentPickedQty)
      }
      totalQty = receivedCount ? totalQty - receivedCount : totalQty
      // CHECK WITH LOCATION STOCK
      let getObj = this.$formatter.cloneVariable(this.orderItems[index])
      if (getObj) {
        let getLocationId = getObj.adjustorder.locationid
        let stockObj = getObj.locations.find(x => x.locationid === getLocationId)
        if (stockObj) {
          let stockValue = +parseFloat(this.$formatter.replaceCommaWithDot(stockObj.onstock || 0))
          if (stockValue < totalQty) {
            this.$root.$emit('snackbar', {
              snackbar: true,
              color: 'error',
              text: this.$t('message.common.qtyExceeds')
            })
            setTimeout(() => {
              getObj.pickedqty = ''
              this.$set(this.orderItems, index, getObj)
            })
          }
        }
      }
      let checkPickedQty = 0
      let parentPickedQty = this.$formatter.replaceCommaWithDot(this.orderItems[index].pickedqty)
      checkPickedQty = loopCount + +parentPickedQty
      if (+parseFloat(this.$formatter.replaceCommaWithDot(this.orderItems[index].qty)) < checkPickedQty) {
        this.$root.$emit('snackbar', {
          snackbar: true,
          color: 'error',
          text: this.$t('message.common.qtyExceeds')
        })
        totalQty = +parseFloat(this.$formatter.replaceCommaWithDot(this.orderItems[index].qty)) - parseFloat(loopCount)
        setTimeout(() => {
          getObj.pickedqty = this.$formatter.replaceDotWithComma(totalQty)
          this.$set(this.orderItems, index, getObj)
        })
      }
      if (getObj.pickedqty) this.needToReceive = false
      else this.needToReceive = true
      this.checkQtyOfBatchNumber(index)
    },
    checkQtyOfBatchNumber (index) {
      let allItems = this.$formatter.cloneVariable(this.orderItems)
      let getObj = allItems[index]
      if (getObj) {
        // get all the qty connected with this batch number
        let getBatch = getObj.batchnumber
        let qtyWithBatch = 0
        let totalRecQty = 0
        let countAllQty = getObj.pickedorders.filter(x => x.batchnumber === getBatch)
        let countAllReceivedQty = getObj.receivedorders
        countAllQty.map(x => {
          qtyWithBatch += +parseFloat(this.$formatter.replaceCommaWithDot(x.pickedqty || 0))
        })
        countAllReceivedQty.map(y => {
          totalRecQty += +parseFloat(this.$formatter.replaceCommaWithDot(y.receivedqty || 0))
        })
        qtyWithBatch += +parseFloat(this.$formatter.replaceCommaWithDot(getObj.pickedqty || 0))
        let stockObj = getObj.batch_numbers.find(x => x.batchnumber === getBatch)
        qtyWithBatch = totalRecQty ? qtyWithBatch - totalRecQty : qtyWithBatch
        if (stockObj) {
          let stockValue = +parseFloat(this.$formatter.replaceCommaWithDot(stockObj.onstock || 0))
          let qty = +parseFloat(this.$formatter.replaceCommaWithDot(qtyWithBatch || 0))
          if (qty > stockValue) {
            setTimeout(() => {
              getObj.pickedqty = ''
              getObj.batchnumber = ''
              this.$set(this.orderItems, index, getObj)
            })
            this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: this.$t('message.whOrder.onstockLessMsg') })
          }
        }
      }
    },
    navigateHandler (type, id, autoSave) {
      if (!this.$route.params.transfer_id && autoSave) {
        this.$router.push(`/w_h/order/transferorder/actions/${id}?autosave=true`).catch((err) => err)
      } else {
        if (autoSave) this.getSingleRecordHandler()
        if (!autoSave && this.$route.params.transfer_id && type !== this.UPDATE_CLOSE) this.getSingleRecordHandler()
        if (!autoSave && type === this.SAVE && !id) this.$router.push(`/w_h/order/transferorder/actions/${id}`)
        else if (!autoSave && type === this.UPDATE_CLOSE) this.$router.push('/w_h/order')
      }
      // if (type === this.SAVE && id) this.getSingleRecordHandler()
    },
    deleteHandler () {
      let ids = [this.transferObj.id]
      let payload = { ids, url: `${this.WH_ORDER}/delete_multiple`, module: this.WH_ORDER }
      this.$store.commit('showDeleteDialog', payload)
    },
    // Show and Hide products in the array for performence when having more items
    toggleAllProducts (index, action, productId) {
      let items = this.$formatter.cloneVariable(this.orderItems)
      if (action === this.HIDE && items[index] && items[index].products) {
        let products = items[index].products.filter(x => x.id === productId)
        items[index].products = products
      }
      if (this.orderItems && this.orderItems.length > 0 && this.orderItems[index]) this.$set(this.orderItems, index, items[index])
      this.autoSave()
    },
    deleteProductRow (index, id) {
      if (this.orderItems[index].id) {
        let payload = { ids: [id], url: `${this.ORDERITEMS}/delete_multiple`, module: this.ORDERITEMS, orderItemsAutoSave: this.$route.params.transfer_id || null }
        this.$store.commit('showDeleteDialog', payload)
      } else this.orderItems.splice(index, 1)
    },
    onScroll () {
      if (window.pageYOffset <= 0) this.showScrollToTop = false
      else this.showScrollToTop = true
      setTimeout(() => {
        this.onResize()
      })
    },
    onResize () {
      this.showScrollToBottom = window.innerWidth > document.documentElement.clientWidth
    },
    scrollToTop () {
      goTo(0)
    },
    goToBottom () {
      goTo(this.pageHeight)
    },
    changesMade () {
      this.$store.commit('isChangesMade', true)
    }
  },
  beforeRouteLeave (to, from, next) {
    if (!this.$store.state.isChangesMade) {
      next()
    } else {
      this.$store.commit('isChangesMade', true)
      this.$store.commit('changeLostDialog', true)
    }
  },
  beforeDestroy () {
    this.$eventBus.$off('deleteSuccess')
  }
}
</script>
